import React, { useEffect } from "react";
import Swal from 'sweetalert2'
import {
    WriteDataStorage,
    ReadDataStorage,
    USERNAME,
} from "./../services/auth";

export default function Logoff(props) {
    console.log(props)
    useEffect(() => {

        Swal.fire({
            text: "Deseja realmente sair do sistema?",
            icon: 'warning',
            title: 'Sair do Sistema',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: 'Não',
            cancelButtonColor: '#3085d6',
            confirmButtonColor: 'lightgray',
            cancelButtonText: `Sim`,
        }).then(async (result) => {
            if (result.isDismissed) {
                const _user = ReadDataStorage(USERNAME)
                const _banco = ReadDataStorage('BD_SETA_BD')
                localStorage.clear();
                if ((_user !== undefined) || (_user !== null) || (_user !== ''))
                    await WriteDataStorage(USERNAME, _user)

                if ((_banco !== undefined) || (_banco !== null) || (_banco !== ''))
                    await WriteDataStorage('BD_SETA_BD', _banco)

                window.location.href = '/login'
            } else {
                props.history.goBack()
            }
        })

    }, []);





    return (<></>);
}
